import { useState, useEffect } from "react";
import isEqual from "lodash/isEqual";

export const useCheckboxSelect = ({
  /* eslint-disable-next-line @typescript-eslint/no-unused-vars -- TODO(eslint-baseline): address @typescript-eslint/no-unused-vars */
  type,
  setSelectedItems,
  selectedItems,
  applyOnClose,
  defaultSelected,
  withCategory,
  options,
  openSetter,
  hideApply,
  open,
}: {
  type: "checkbox" | "filter" | "select";
  setSelectedItems: (items: string[]) => void;
  selectedItems: string[];
  applyOnClose?: boolean;
  defaultSelected?: string[];
  withCategory?: boolean;
  options:
    | Array<{ value: string; label: string }>
    | Array<Record<string, Array<{ value: string; label: string }>>>;
  openSetter?: (isOpen: boolean) => void;
  hideApply?: boolean;
  open: boolean;
}) => {
  const initialChecked =
    selectedItems?.length > 0 ? selectedItems : defaultSelected || [];

  const [checkedItems, setCheckedItems] = useState(initialChecked);

  useEffect(() => {
    if (!isEqual(selectedItems, checkedItems) && !applyOnClose) {
      if (selectedItems?.length > 0) {
        if (typeof selectedItems[0] === "string") {
          setCheckedItems(selectedItems);
          return;
        }
        setCheckedItems(selectedItems.map((item) => item));
        return;
      }
      setCheckedItems(initialChecked);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
  }, [selectedItems, open]);

  useEffect(() => {
    if (hideApply) {
      setSelectedItems(checkedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
  }, [checkedItems]);

  useEffect(() => {
    if (openSetter) {
      openSetter(open);
    }

    if (
      applyOnClose &&
      checkedItems !== selectedItems &&
      checkedItems?.length > 0 &&
      !open
    ) {
      setSelectedItems(checkedItems);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO(eslint-baseline): address react-hooks/exhaustive-deps
  }, [open]);

  const allChecked = withCategory
    ? checkedItems?.length ===
      options?.reduce((acc, item) => {
        const key = Object.keys(item)[0];
        const group = (
          item as Record<string, Array<{ value: string; label: string }>>
        )[key];
        return acc + group.length;
      }, 0)
    : checkedItems?.length === options?.length;

  const handleCheck = (value: string) => {
    setCheckedItems((checked) => [...checked, value]);
  };
  const handleUncheck = (value: string) => {
    setCheckedItems((checked) => checked.filter((v) => v !== value));
  };

  const handleClearAll = () => {
    setCheckedItems([]);
  };

  const handleSelectVarious = (values: string[]) => {
    setCheckedItems(values);
  };

  return {
    checkedItems,

    allChecked,
    handleCheck,
    handleUncheck,
    handleClearAll,
    handleSelectVarious,
    initialChecked,
  };
};
